module.exports = __webpack_public_path__ + "static/media/menu bar.972465d2.png";